/* eslint-disable */
import React, { useState, Suspense, useEffect, useContext, useCallback, useRef } from "react";
import "../group.css";
import { Paper, TextField, Button, InputAdornment, Checkbox, MenuItem, Select } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import SendIcon from "@material-ui/icons/Send";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import IconButton from "@mui/material/IconButton";
import SnackbarAPICall from "../../../../shared/snackbar/SnackbarAPICall";
import CustomizedSwitches from "../../../../shared/switchButton/SwitchButton";
import { AuthContext, UIContext } from "../../../../../contexts";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../constants/caption/dashboardHeader";
import { api } from "../../../../../utils/api";
import {
	Grid,
	Box,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	InputLabel,
	Typography
} from "@material-ui/core";
import { trackPromise } from "react-promise-tracker";
import { SnackbarProps } from "../../../../../@types/snackbarAPI.types";
import { EMPLOYEE_CLASS } from "../../../../../constants/employeeClass";
import { PAY_FREQUENCY_V3 } from "../../../../../constants/payFrequency";
import { Element } from "react-scroll";
import { LazyChangeLogo } from "../../..";
import generateImageUrl from "../../../../../utils/commonFunctions/imageUrl";
import { get } from "http";

const mailformat = /^[a-zA-Z0-9.!#$%&'+/=?^_{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)$/;
interface PaycheckConfig {
	pay_frequency: string;
	rate_type: string[];
	hourly_multiplication: string | number;
}

const PreviewGroup = () => {
	const navigate = useNavigate();
	const { setDashboardHeader } = useContext(UIContext);
	const { user } = useContext(AuthContext);
	const [assignedGroups, setAssignedGroups] = useState([]);

	const [paycheckConfigs, setPaycheckConfigs] = useState<PaycheckConfig[]>([]);

	const [logoSettings, setLogoSettings] = useState<any>({});

	const [formData, setFormData] = useState<{
		name: string;
		group_number: number | string;
		address_1: string;
		address_2: string;
		city: string;
		state: string;
		zip: string;
		country: string;
		// status: string;
		contact_number: string;
		email: string;
		claims_integration: boolean;
		// is_SSN_required?: boolean;
		employee_class: string[];
		// paycheck_config?: PaycheckConfig[];
		// buy_up_eligibility: boolean;
		claim_engine: Object[];
		SSN_provided_by_group: boolean;
	}>({
		name: "",
		group_number: "",
		address_1: "",
		address_2: "",
		city: "",
		state: "",
		zip: "",
		country: "",
		// status: "",
		contact_number: "",
		email: "",
		claims_integration: false,
		// is_SSN_required: true,
		employee_class: [],
		// paycheck_config: [],
		// buy_up_eligibility: false,
		claim_engine: [],
		SSN_provided_by_group: false
	});

	// For Edit
	const [searchParams] = useSearchParams();
	const gn = searchParams.get("gn");
	const isEditMode = Boolean(gn);

	const [snackbarAPICallProps, setSnackbarAPICallProps] = useState<SnackbarProps>({
		open: false,
		severity: undefined,
		message: "",
		handleSnackbarClose: (event, reason) => {
			if (reason === "clickaway") return;
			setSnackbarAPICallProps(
				Object.assign({}, snackbarAPICallProps, {
					open: false
				})
			);
		}
	});
	const _validation = useRef<any>({});
	const [validation, setValidation] = useState<any>({
		status: "invalid",
		group: {}
	});

	const handleReturnToGroups = useCallback(
		(groupNumber: string | number) => {
			navigate(`/create-group/group-page-design?gn=${groupNumber}`);
		},
		[navigate]
	);

	const getAssignGroups = useCallback(async () => {
		const params = {
			user_id: user?._id
		};
		const response = await api.assignGroupsAndLocation.getAssignedGroupsAndLocations(params);

		if (response) {
			const _assignedGroups: any[] = [];
			response.groupsAndLocations.forEach((group: any) => {
				if (group.assigned_group_info) {
					_assignedGroups.push(group);
				}
			});

			setAssignedGroups(Object.assign([], _assignedGroups));
		}
	}, [user?._id]);

	const availablePayFrequencies = PAY_FREQUENCY_V3.filter(
		(freq) => !paycheckConfigs.some((config) => config.pay_frequency === freq)
	);

	const getLogoSettings = useCallback(async (group_number: any) => {
		const _logoSettings = await trackPromise(api.employeePageDesign.getLogoSettingsByGroupNumber(group_number));
		console.log("_logoSettings", _logoSettings);
		if (_logoSettings === false) {
			setLogoSettings(
				Object.assign(
					{},
					{
						logo: {
							attachment: null,
							xl: {
								height: 200,
								width: 100
							},
							lg: {
								height: 200,
								width: 100
							},
							md: {
								height: 200,
								width: 100
							},
							sm: {
								height: 200,
								width: 100
							},
							xs: {
								height: 200,
								width: 100
							}
						},
						favicon: null,
						group_number
					}
				)
			);
			return;
		}
		setLogoSettings(Object.assign({}, _logoSettings));
	}, []);

	const groupData = useCallback(async (groupNumber: number) => {
		await getLogoSettings(groupNumber);
		const res: any = await trackPromise(api.group.getGroupByGroupNumber(groupNumber));
		if (res) {
			const { paycheck_config, claim_engine, buy_up_eligibility, ...restData } = res;
			// setFormData(restData);
			setFormData({
				...restData,
				claim_engine: Array.isArray(claim_engine) ? claim_engine : []
			});

			if (res.paycheck_config && Array.isArray(res.paycheck_config)) {
				const normalizedConfigs = res.paycheck_config.map((config: PaycheckConfig) => {
					const isOnlyFixed = config.rate_type.includes("FIXED") && !config.rate_type.includes("HOURLY RATE");

					return {
						...config,
						hourly_multiplication:
							isOnlyFixed && (!config.hourly_multiplication || Number(config.hourly_multiplication) === 0)
								? 1
								: config.hourly_multiplication
					};
				});
				setPaycheckConfigs(normalizedConfigs);
			}
		}
	}, []);

	useEffect(() => {
		if (isEditMode && gn) {
			const groupNumber = Number(gn);
			if (!isNaN(groupNumber)) {
				groupData(groupNumber);
			}
		}
	}, [isEditMode, gn, groupData]);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.view_group);
		getAssignGroups();
	}, [getAssignGroups, setDashboardHeader]);

	return (
		<div className="create-group" id="create-group">
			<Suspense fallback={<div />}>
				<SnackbarAPICall snackbarProps={snackbarAPICallProps} />
			</Suspense>

			{/* Main Form */}
			<Paper className="pf-paper-container" elevation={3} variant="outlined" style={{ padding: 40 }}>
				<Grid container spacing={2}>
					<Grid
						container
						spacing={2}
						alignItems="center"
						key={"logo_settingsoo"}
						style={{ marginBottom: 30 }}
					>
						<Grid item xs={12} sm={4} md={3}>
							<Typography
								variant="subtitle2"
								// className="pf-label-text "
								className={`pf-label-text ${""}`}
								style={{
									textTransform: "capitalize",
									whiteSpace: "nowrap",
									color: "#424242",
									fontWeight: "bold",
									fontSize: "1rem"
								}}
							>
								Group Logo
							</Typography>
						</Grid>
						<Grid item xs={12} sm={8} md={6}>
							{logoSettings && logoSettings.logo && logoSettings.logo.attachment ? (
								<img
									src={generateImageUrl(logoSettings.logo.attachment)}
									height={60}
									width={350}
									alt="logo"
								/>
							) : (
								"No logo uploaded yet."
							)}
						</Grid>
					</Grid>
					{/* // formdata rendering */}
					{Object.entries(formData)
						.filter(([key]) => !["employee_class", "claim_engine"].includes(key))
						.map(([key, value], index) => (
							<Grid container spacing={2} alignItems="center" key={index} style={{ marginBottom: 30 }}>
								<Grid item xs={12} sm={4} md={3}>
									<Typography
										variant="subtitle2"
										className={`pf-label-text`}
										style={{
											textTransform: "capitalize",
											whiteSpace: "nowrap",
											color: "#424242",
											fontWeight: "bold",
											fontSize: "1rem"
										}}
									>
										{key.replace(/_/g, " ")}
									</Typography>
								</Grid>
								<Grid item xs={12} sm={8} md={6}>
									{typeof value === "boolean" ? (
										<Checkbox
											name={key}
											checked={value}
											disabled
											sx={{
												color: "#4caf50",
												"&.Mui-checked": {
													color: "#4caf50"
												}
											}}
										/>
									) : (
										<TextField
											name={key}
											placeholder={`N/A`}
											value={value}
											disabled
											variant="outlined"
											fullWidth
											type="text"
											style={{ width: "350px" }}
											inputProps={{
												inputMode:
													key === "zip" || key === "contact_number" ? "numeric" : "text",
												maxLength: key === "zip" ? 9 : key === "contact_number" ? 10 : undefined
											}}
											helperText={validation?.group?.[key] || ""}
										/>
									)}
								</Grid>
							</Grid>
						))}

					{formData.claims_integration && (
						<Grid container spacing={2} alignItems="center" style={{ marginBottom: 30 }}>
							<Grid item xs={12} sm={4} md={3}>
								<Typography
									variant="subtitle2"
									className="pf-label-text "
									style={{
										textTransform: "capitalize",
										whiteSpace: "nowrap",
										color: "#424242",
										fontWeight: "bold",
										fontSize: "1rem"
									}}
								>
									Claims Engine
								</Typography>
							</Grid>
							<Grid item xs={12} sm={8} md={6}>
								<FormControl
									fullWidth
									style={{ width: "350px" }}
									error={!!validation?.group?.claim_engine}
								>
									<Select
										multiple
										displayEmpty
										value={formData.claim_engine.map((claimEngine: any) => claimEngine.engineName)}
										disabled
										renderValue={(selected) => {
											if ((selected as string[]).length === 0) {
												return <span style={{ color: "#9e9e9e" }}>N/A</span>;
											}
											return (selected as string[]).join(", ");
										}}
									>
										<MenuItem disabled value="">
											<>Select claim engine</>
										</MenuItem>
										<MenuItem value="WLT">WLT</MenuItem>
										{/* <MenuItem value="EFD">EFD</MenuItem>
										<MenuItem value="XYZ">XYZ</MenuItem> */}
									</Select>
								</FormControl>
							</Grid>
						</Grid>
					)}

					<Grid container spacing={2} style={{ marginBottom: 30 }}>
						<Grid item xs={12} sm={4} md={3}>
							<Typography
								variant="subtitle2"
								className="pf-label-text "
								style={{
									textTransform: "capitalize",
									whiteSpace: "nowrap",
									color: "#424242",
									fontWeight: "bold",
									fontSize: "1rem"
								}}
							>
								Employee Class
							</Typography>
						</Grid>
						<Grid item xs={12} sm={8} md={6}>
							{Object.values(EMPLOYEE_CLASS).map((type) => (
								<div key={type}>
									<Checkbox
										checked={formData.employee_class?.includes(type)}
										disabled
										sx={{
											color: "#4caf50",
											"&.Mui-checked": {
												color: "#4caf50"
											}
										}}
									/>
									{type.replaceAll("_", " ").replace(/\b\w/g, (types) => types.toUpperCase())}
								</div>
							))}
						</Grid>
					</Grid>

					<Grid item xs={12}>
						<Typography variant="subtitle2" style={{ marginTop: "16px" }}>
							Added Paycheck Configs:
						</Typography>
						{paycheckConfigs.length === 0 ? (
							<Typography variant="body2">No Paycheck configs added yet.</Typography>
						) : (
							paycheckConfigs.map((config: any, index: any) => (
								<Box
									key={index}
									style={{
										border: "1px solid #ccc",
										padding: 8,
										marginTop: 8,
										position: "relative",
										width: "100%",
										maxWidth: "700px"
									}}
								>
									<strong>Frequency:</strong> {config.pay_frequency} <br />
									<strong>Rate Types:</strong> {config.rate_type.join(", ")} <br />
									{/* <strong>Hourly Mult:</strong> {config.hourly_multiplication} */}
									{config.rate_type.includes("HOURLY RATE") && (
										<>
											<strong>Hourly Multiplication:</strong> {config.hourly_multiplication}
										</>
									)}
								</Box>
							))
						)}
					</Grid>
				</Grid>
			</Paper>
		</div>
	);
};

export default PreviewGroup;
